import { ChangeEvent, useMemo, useState } from 'react';
import { useDebouncedValue } from '@/hooks';
import { SEARCH_DEBOUNCE_DELAY_MS } from '@/constants/common';
import { ILLMTemplateVariable } from '@/models/llmTemplate.model';

export const useLLMTemplateVariablesSearch = (variables: ILLMTemplateVariable[] | null) => {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebouncedValue(query, SEARCH_DEBOUNCE_DELAY_MS);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const filteredVariables = useMemo(() => {
    if (!variables) return [];

    const normalizedQuery = debouncedQuery.trim().toLowerCase();
    if (!normalizedQuery) return variables;

    return variables.filter(
      (variable) =>
        variable.code.toLowerCase().includes(normalizedQuery) ||
        variable.placeholder.toLowerCase().includes(normalizedQuery) ||
        variable.description.toLowerCase().includes(normalizedQuery),
    );
  }, [variables, debouncedQuery]);

  return { query, handleSearchChange, filteredVariables };
};
